import React from "react";
import {Card, ListGroup} from "react-bootstrap";
import RulesEditStructLengthEntry from "./RulesEditStructLengthEntry";


class RulesEditStructLength extends React.Component{
    editRuleEntry(index,nval) {
        if(nval == null){
            if(window.confirm("Are you sure you want to remove this rule?")){
                this.props.data[index].delete=true;
                this.props.cb(this.props.data);
                this.forceUpdate()
            }
        }else{
            this.props.data[index]=nval;
            this.props.data[index].modified = true;
            this.props.cb(this.props.data);
            this.forceUpdate()
        }
    }
    render(){
        return (

            <Card>
                <Card.Header>
                    <span>Length penalty</span>
                </Card.Header>
                <ListGroup variant="flush">
                    {this.props.data.map((val,i) =>
                        val.delete === undefined && val.ruleType === "lengthRules" ? <RulesEditStructLengthEntry key={i} data={val} cb={(nval) => {this.editRuleEntry(i,nval)}}/> : ''
                    )}
                </ListGroup>
            </Card>
        )
    }
}
export default RulesEditStructLength;